// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2IetK","tabs":"LayoutWrapperSideNav_tabs__3gh2S","tab":"LayoutWrapperSideNav_tab__XIvi8"};